import { createFileRoute } from "@tanstack/react-router";
import LeafBlowerGuide from "@/pages/LeafBlowerGuide";

export const Route = createFileRoute("/leaf-blower-guide")({
  component: LeafBlowerGuide,
  head: () => {
    const title = "Best Leaf Blowers UK: Buying Guide | Garden Review";
    const description = "Compare cordless, electric and petrol leaf blowers for UK gardens. Learn about airflow, weight, vacuum functions and choosing the right power source.";
    const url = "https://www.garden-review.co.uk/leaf-blower-guide";

    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "article" },
        { property: "og:url", content: url },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
});
